module.exports = __webpack_public_path__ + "img/con_8.b44dd919.svg";